import {Dispatch} from "redux";
import {AccountAPI, BrandsAPI, TastesAPI} from "../services/api/Api";
import {generateUUID} from "../services/utils/uuid";
import {getRecommendationsData} from "./Main";
import {initializationData} from "./Favorite";
import {IBrands, ITastes} from "../constants/types";
import {regExShareMix} from "../constants";

const SET_ACTIVE_PAGE = 'System/SET_ACTIVE_PAGE';
const GET_TOKEN_START = 'System/GET_TOKEN_START';
const GET_TOKEN_SUCCESS = 'System/GET_TOKEN_SUCCESS';
const GET_TASTES_SUCCESS = 'System/GET_TASTES_SUCCESS';
const GET_BRANDS_SUCCESS = 'System/GET_BRANDS_SUCCESS';

interface ISystemState {
    activePage: string,
    isLoading: boolean,
    isUserAuth: boolean,
    tastes: Array<ITastes> | null,
    brands: Array<IBrands> | null,
}

interface ISystemAction {
    type: string,
    payload: any
}

const initialState: ISystemState = {
    activePage: "MAIN",
    isLoading: true,
    isUserAuth: false,
    brands: [],
    tastes: []
};

export const setActivePage = (page: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({
            type: SET_ACTIVE_PAGE,
            payload: page
        })
    }
};


export const getTobaccoInformation = () => async (dispatch: Dispatch) => {
    Promise.all([TastesAPI.getListTastes(), BrandsAPI.getBrands()])
        .then(value => {
            dispatch({
                type: GET_TASTES_SUCCESS,
                payload: value[0]
            });
            dispatch({
                type: GET_BRANDS_SUCCESS,
                payload: value[1]
            });
        })
        .catch(e => console.log(e));
};

export const getUserPreferences = (history: any) => async () => {
    const preferences = await AccountAPI.getAccountPreferences();
    if (regExShareMix.test(window.location.hash)) {
        return false;
    }
    if (Object.keys(preferences).length === 3) {
        history.push("/main");
    }
};

export const getTokenFromServer = (uuid: any, history: any) => async (dispatch: Dispatch) => {
    AccountAPI.getAuthToken(uuid)
        .then(() => dispatch({type: GET_TOKEN_SUCCESS}))
        .then(() => dispatch<any>(getUserPreferences(history)))
        .then(() => dispatch<any>(getRecommendationsData()))
        .then(() => dispatch<any>(getTobaccoInformation()))
        .catch(e => console.log(e));
};

export const initApp = (history: any) => async (dispatch: Dispatch) => {
    dispatch({type: GET_TOKEN_START});
    const uuid = localStorage.getItem('uuid');
    if (uuid) {
        dispatch<any>(getTokenFromServer(uuid, history));
    } else {
        localStorage.setItem('uuid', generateUUID);
        const newUuid = localStorage.getItem('uuid');
        dispatch<any>(getTokenFromServer(newUuid, history))
    }
    dispatch<any>(initializationData())
};

const SystemReducer = (state = initialState, action: ISystemAction): ISystemState => {

    switch (action.type) {
        case SET_ACTIVE_PAGE:
            return {
                ...state,
                activePage: action.payload
            };

        case GET_TOKEN_START: {
            return {
                ...state,
                isLoading: true
            };
        }

        case GET_TOKEN_SUCCESS: {
            return {
                ...state,
                isUserAuth: true
            };
        }

        case GET_TASTES_SUCCESS: {
            return {
                ...state,
                tastes: action.payload
            }
        }

        case GET_BRANDS_SUCCESS: {
            return {
                ...state,
                brands: action.payload,
                isLoading: false
            }
        }

        default:
            return state;
    }
};

export default SystemReducer;
